// import { joPhotoDesktop } from "../assets";
import { Container } from "../components/Container/Container";
import { useTranslation } from "react-i18next";
import { FadeInOnScroll } from "../components/FadeInOnScoll/FadeInOnScroll";

export const Bio = () => {
  const { t } = useTranslation();

  return (
    <div
      className="bg-white relative z-10 pb-14"
      style={{
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 90%)",
      }}
    >
      <Container>
        <FadeInOnScroll>
          <h5 id="bio" className="title-page">
            {t("biography")}
          </h5>
        </FadeInOnScroll>
        <FadeInOnScroll delay={200}>
          <div className="z-10 flex flex-col-reverse lg:flex-row items-center justify-between rounded-xl mb-10 pb-14 lg:pt-14 gap-8">
            <div className="basis-1/2">
              <img
                className="rounded-lg"
                src="../img/photo-concert-noktambul.webp"
                alt="photo du concert au noktambul"
              />
            </div>
            <div className="basis-1/2 flex-col items-center text-justify w-full space-y-6 px-6 font-semibold">
              <p>{t("text-bio-1")}</p>
              <p>{t("text-bio-2")}</p>
              <p>{t("text-bio-3")}</p>
            </div>
          </div>
        </FadeInOnScroll>
      </Container>
    </div>
  );
};
